document.addEventListener("DOMContentLoaded", () => {
  (() => {
  const cssVarInt = (name, fallback) => {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name);
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  };

  const SWATCH = cssVarInt('--swatch-size', 19);
  const GAP    = cssVarInt('--gap-size', 10);
  const VISIBLE = cssVarInt('--visible-swatches', 3);
  const STEP = SWATCH + GAP;

  const init = (wrapper) => {
    const track   = wrapper.querySelector('[data-carousel-track]');
    const prevBtn = wrapper.querySelector('[data-carousel-prev]');
    const nextBtn = wrapper.querySelector('[data-carousel-next]');
    if (!track || (!prevBtn && !nextBtn)) return;

    // Collect swatch items (custom element tag)
    const items = Array.from(track.querySelectorAll('maison-swatch'));
    const total = items.length;

    // If nothing to scroll, disable both buttons and bail
    if (total <= VISIBLE) {
      prevBtn?.classList.add('hidden');
      nextBtn?.classList.add('hidden');
      // Also ensure track at origin
      track.style.transform = 'translateX(0)';
      return;
    }

    let index = 0; // leftmost visible item index

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const maxIndex = Math.max(0, total - VISIBLE);

    const applyTransform = () => {
      const x = -(index * STEP);
      // Use transform only; do not write width/overflow etc.
      track.style.transform = `translateX(${x}px)`;
    };

    const updateButtons = () => {
      const atStart = index <= 0;
      const atEnd   = index >= maxIndex;
      prevBtn?.classList.toggle('hidden', atStart);
      nextBtn?.classList.toggle('hidden', atEnd);
    };

    const goPrev = () => {
      index = clamp(index - 1, 0, maxIndex);
      applyTransform();
      updateButtons();
    };

    const goNext = () => {
      index = clamp(index + 1, 0, maxIndex);
      applyTransform();
      updateButtons();
    };

    // Wire clicks
    prevBtn?.addEventListener('click', goPrev, { passive: true });
    nextBtn?.addEventListener('click', goNext, { passive: true });

    // Block native wheel/touch/keyboard scroll on the viewport/track
    const prevent = (e) => e.preventDefault();
    const viewport = wrapper.querySelector('.carousel-inner-wrapper') || track;
    viewport.addEventListener('wheel', prevent, { passive: false });
    viewport.addEventListener('touchmove', prevent, { passive: false });
    viewport.addEventListener('keydown', (e) => {
      if (['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown',' '].includes(e.key)) e.preventDefault();
    });

    // Initial paint — do not read scrollWidth/clientWidth at all
    requestAnimationFrame(() => {
      applyTransform();
      updateButtons();
    });

    // If your template adds/removes swatches later, re-calc maximum
    // Minimal observer: only recompute maxIndex when children change
    const mo = new MutationObserver(() => {
      const newTotal = track.querySelectorAll('maison-swatch').length;
      if (newTotal !== total) {
        // If count changes, clamp index and refresh
        const newMax = Math.max(0, newTotal - VISIBLE);
        index = clamp(index, 0, newMax);
        applyTransform();
        updateButtons();
      }
    });
    mo.observe(track, { childList: true });
  };

  document.querySelectorAll('.carousel-outer-wrapper').forEach(init);
 })();
});